<template>
  <LayoutCard title="License Workflow">
    <template #description>
      <div>
        Use this section to define the statuses a license may fall under (e.g. active, pending, suspended, etc.). Each
        status must be assigned one of the following types:
      </div>
      <ul>
        <li>
          Active: The property owner is allowed to list the property with no further action needed until the next
          renewal period.
        </li>
        <li>
          Pending: The property owner needs to complete additional steps before they should list the property, but
          listings for this property should not yet be deemed violations.
        </li>
        <li>
          Inactive: The property owner should not list the property yet, and any listings are treated as violations.
        </li>
      </ul>
      <div>
        Expired is derived from the expiration date, and Deleted is managed as an internal record state, so neither is
        part of the editable workflow.
      </div>
    </template>

    <template #footer v-if="changed">
      <button type="button" class="btn btn-flat ms-1" @click="reset">
        Cancel
      </button>
      <button type="button" class="btn btn-primary ms-1" @click="commit">
        Save Changes
      </button>
    </template>

    <template #flush>
      <div v-if="workflow" class="list-group list-group-flush border-top border-bottom">
        <LicenseWorkflowEditorRow
          v-for="(status, i) in workflow.statuses"
          :key="status.id"
          class="list-group-item"
          :show-labels="i === 0"
          :workflow="workflow"
          :status-id="status.id"
          @remove="removeStatus"
        />
        <div class="d-flex flex-row align-items-center p-4 gap-2">
          <button type="button" class="btn btn-primary" @click="addStatus">
            Add Custom Status
          </button>
          <label class="form-label ms-auto mb-0">Default:</label>
          <div>
            <select class="form-select" v-model="workflow.defaultStatus">
              <option :value="null">Select one</option>
              <option
                v-for="status in workflow.statuses"
                :key="status.id"
                :value="status.id">{{ status.label }}</option>
            </select>
          </div>
        </div>
      </div>
    </template>
  </LayoutCard>
</template>

<script>
import LayoutCard from "@/components/common/LayoutCard.vue";
import {City} from "@/models/City";
import {LicenseWorkflow} from "@/models/LicenseWorkflow";
import LicenseWorkflowEditorRow from "@/components/admin-city/licenses/LicenseWorkflowEditorRow.vue";
export default {
  components: {LicenseWorkflowEditorRow, LayoutCard},
  props: {
    city: City
  },
  data() {
    return {
      workflow: null,
      original: null
    };
  },
  watch: {
    city: {
      immediate: true,
      handler() {
        this.workflow = new LicenseWorkflow(this.city);
        this.updateOriginal();
      }
    }
  },
  computed: {
    changed() {
      return this.original !== JSON.stringify(this.workflow.serialize());
    }
  },
  methods: {
    updateOriginal() {
      this.original = JSON.stringify(this.workflow.serialize());
    },
    reset() {
      this.workflow.reset();
      this.updateOriginal();
    },
    async commit() {
      await this.workflow.commit();
      this.updateOriginal();
      this.$showToast('License workflow saved');
    },
    addStatus() {
      this.workflow.addStatus();
    },
    removeStatus(id) {
      this.workflow.removeStatus(id);
    }
  }
}
</script>
